/** IAMPAM ITops Portal 제품 버전 (UI·문서·health API 공통) */
export const PORTAL_VERSION = '4.0' as const

export const PORTAL_VERSION_SEMVER = '4.0.0' as const

export const PORTAL_VERSION_LABEL = `V${PORTAL_VERSION}` as const

export const PORTAL_VERSION_FOOTER = `IAMPAM ITops version ${PORTAL_VERSION}` as const

export const PORTAL_DOCUMENT_TITLE = `IAMPAM ITops ${PORTAL_VERSION_LABEL}` as const
